import dayjs from "dayjs";

export interface ExaminationWithInterval {
  id: string;
  interval_in_days?: number | null;
}

export const toSelectedExaminationIds = (examSelection: unknown): string[] => {
  if (Array.isArray(examSelection)) {
    return examSelection.filter(Boolean).map(String);
  }
  return examSelection ? [String(examSelection)] : [];
};

const addDays = (executedOn: string, days: number) =>
  dayjs(executedOn).add(days, "day").format("YYYY-MM-DD");

export const calculateValidUntil = (
  examinations: ExaminationWithInterval[],
  selectedExaminationIds: string[],
  executedOn: string
): string | null => {
  const intervalOf = (id: string) =>
    examinations.find((examination) => examination.id === id)?.interval_in_days;

  if (selectedExaminationIds.length === 1) {
    const interval = intervalOf(selectedExaminationIds[0]);
    if (!interval) return null;
    return addDays(executedOn, interval);
  }

  // preserved quirk: several examinations use the longest positive interval; a single one accepts any truthy value
  const positiveIntervals = selectedExaminationIds
    .map(intervalOf)
    .filter((days): days is number => typeof days === "number" && days > 0);
  if (positiveIntervals.length === 0) return null;
  return addDays(executedOn, Math.max(...positiveIntervals));
};
